// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a4b58c5f","453":"26c5dd05","455":"b57e22de"}[chunkId] + ".chunk.js";
};